export const CREATE_TASK = "CREATE_TASK";
export const TASK_MASTER_LIST = "TASK_MASTER_LIST";
export const PROJECT_DROPDOWN = "PROJECT_DROPDOWN";
export const TASK_DATA_EDIT = "TASK_DATA_EDIT";
export const TASK_REPORT_EMP_WISE = "TASK_REPORT_EMP_WISE";
export const TASK_STATUS = "TASK_STATUS";
export const TASK_PRIORITY = "TASK_PRIORITY";
export const TASK_TYPE = "TASK_TYPE";
export const TASK_ASSIGN_LIST = "TASK_ASSIGN_LIST";
export const TASK_COMMENT = "TASK_COMMENT";
export const TASK_WORKLOG = "TASK_WORKLOG";
export const TASK_WORKLOG_DATA = "TASK_WORKLOG_DATA";
export const TASK_COMMENT_DATA = "TASK_COMMENT_DATA";
export const TASK_MASTER_DASH_DATA = "TASK_MASTER_DASH_DATA";
export const TASK_NO_SEARCH_LIST = "TASK_NO_SEARCH_LIST";
export const TASK_DETAILS = "TASK_DETAILS";
export const FETCH_WORKLOG_DATA = "FETCH_WORKLOG_DATA";
export const FETCH_TASK_PROJECTWISE_DATA = "FETCH_TASK_PROJECTWISE_DATA";
export const TODAYS_WORKLOG_DATA_BYID = "TODAYS_WORKLOG_DATA_BYID";
